<script setup lang="ts">
import type { INews } from '~/components/entity/news'
import type { IResponseData } from '~/types'
import type { IProps } from './types'

const props = withDefaults(defineProps<IProps>(), {
  path: '/news'
})

const url = computed(() => useUrlWithParams(props.path, props.queryParams))

const { data } = useApi<IResponseData<INews[]>>(() => url.value, {
  key: `news-page.${url.value}`
})

const news = computed(() => data.value?.data)
const primaryNews = computed(() => news.value?.at(0))
const secondaryNews = computed(() => news.value?.slice(1))
</script>

<template>
  <div
    v-if="news?.length"
    class="grid grid-cols-1 gap-5 rounded-lg border bg-white px-4 py-6 md:rounded-xl md:px-6 lg:grid-cols-10"
  >
    <article v-if="primaryNews" class="relative space-y-2 lg:col-span-4">
      <badge rounded="full" class="bg-blue-50 font-normal text-gray-700"
        >{{ primaryNews.category }}
      </badge>
      <Heading tag="h3" class="h5">
        <NuxtLinkLocale
          :to="primaryNews.url"
          class="block after:absolute after:inset-0 hover:underline"
          >{{ primaryNews.title }}</NuxtLinkLocale
        >
      </Heading>
      <p>{{ primaryNews.summary }}</p>
    </article>
    <div class="space-y-2.5 lg:col-span-6">
      <article v-for="newsItem in secondaryNews" :key="newsItem.id">
        <NuxtLinkLocale :to="newsItem.url" class="hover:underline">{{
          newsItem.title
        }}</NuxtLinkLocale>
      </article>
    </div>
  </div>
</template>
